import { useQuery } from "@tanstack/react-query";
import { getMemberDetail } from "../api/admin";
import { DeleteAdmin } from "../types/types";

const useGetMemberDetail = ({ idx }: DeleteAdmin) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["MemberDetail", `idx-${idx}`],
    queryFn: () => getMemberDetail({ idx }),
    retry: false,
    enabled: !!idx,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  // enabled가 false일 경우 isLoading을 false로 설정
  const loadingStatus = !!idx ? isLoading : false;

  return { data, isLoading: loadingStatus, isSuccess };
};

export default useGetMemberDetail;
